export class HiddenNode {
  public constructor(private hidden: boolean = false) {}

  public hide() {
    this.hidden = true;
  }

  public show() {
    this.hidden = false;
  }

  public isHidden() {
    return this.hidden;
  }
}
